import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The RegionalPurchasingMechanisms's component.
 */
const RegionalPurchasingMechanisms = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-InfoRegional-MecanismosDeCompra.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el tipo de moneda para los datos, puede ser peso chileno o dólar estadounidense.</Item>
        <Item>Corresponde al nombre de cada mecanismo de compra que utiliza el organismo comprador.</Item>
        <Item>Corresponde al nombre de cada mecanismo de compra que utiliza la región.</Item>
        <Item>Monto total transado y número de órdenes de compra correspondiente al mecanismo de compra.</Item>
        <Item>Escala de montos transados en millones de pesos (CLP).</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default RegionalPurchasingMechanisms
